import { ElementType, ReactElement } from 'react';
import { Typography, TypographyProps } from '@mui/material';

import { PoolFormattedMessage } from '../pool-formatted-message/pool-formatted-message';

export interface PoolTypographyProps extends TypographyProps<'span', { component?: ElementType }> {
    translationId?: string;
    // any type comes from FormattedMessage base
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    values?: Record<string, any>;
}

export const PoolTypography = (props: PoolTypographyProps): ReactElement => {
    const { children, translationId, values, ...typographyProps } = props;

    return (
        <Typography {...typographyProps}>
            {translationId ? <PoolFormattedMessage id={translationId} values={values} /> : children}
        </Typography>
    );
};
